// extracted by mini-css-extract-plugin
export default {"scrollingCustom":"AllTask_scrollingCustom__3lP9W"};